import * as styles from "./PartnerInfo.module.css";

import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";

import { HtmlOutput } from "@components/html";
import React from "react";

/**
 * Renders the partner info section of the careers opportunities page.
 *
 * This contains sections for why you should join, the engineer testimonial, and two additional sections.
 *
 * @param {{ whyYouShouldJoinTitle: string, whyYouShouldJoinReasons: string[], section1: string, section2: string, engineerTestimonialTitle: string, engineerTestimonialImage: IGatsbyImageData | undefined, engineerTestimonialImageTitle: string, engineerTestimonialContent: string }}} props
 * The props object containing the title, list of reasons, two sections and engineer testimonial content to be used in the component.
 * @returns {JSX.Element} The rendered component.
 */
const PartnerInfo = ({
  whyYouShouldJoinTitle,
  whyYouShouldJoinReasons,
  section1,
  section2,
  engineerTestimonialTitle,
  engineerTestimonialImage,
  engineerTestimonialImageTitle,
  engineerTestimonialContent,
}: {
  whyYouShouldJoinTitle: string;
  whyYouShouldJoinReasons: string[];
  section1: string;
  section2: string;
  engineerTestimonialTitle: string;
  engineerTestimonialImage: IGatsbyImageData | undefined;
  engineerTestimonialImageTitle: string;
  engineerTestimonialContent: string;
}) => {
  return (
    <section className={styles.opiContainer}>
      <div className={`inner ${styles.opiContainerInner}`}>
        <div className={styles.opiContainerColumn}>
          {/* Why you should join */}
          <div className={`${styles.opiContainerCell} ${styles.opiWysj}`}>
            <h2>{whyYouShouldJoinTitle}</h2>

            {/* List of reasons */}
            <div className={styles.opiWysjReasons}>
              {whyYouShouldJoinReasons.map((r, i) => {
                return <em key={`em_wysjr_${i}`}>&ldquo;{r}&rdquo;</em>;
              })}
            </div>
          </div>

          {/* Section 1 */}
          <div className={`${styles.opiContainerCell} ${styles.opiSection1}`}>
            <HtmlOutput html={section1} />
          </div>

          {/* Engineer Testimonial containint title, image of engineer, and content */}
          <div
            className={`${styles.opiContainerCell} ${styles.opiETContainer}`}
          >
            <h2>{engineerTestimonialTitle}</h2>
            <div className={styles.opiET}>
              {engineerTestimonialImage && (
                <GatsbyImage
                  image={engineerTestimonialImage}
                  alt={engineerTestimonialImageTitle}
                  className={styles.opiETImg}
                />
              )}
              <div className={styles.opiETContent}>
                <HtmlOutput html={engineerTestimonialContent} />
              </div>
            </div>
          </div>
        </div>

        {/* Section 2 */}
        <div className={styles.opiContainerColumn}>
          <div className={`${styles.opiContainerCell} ${styles.opiSection2}`}>
            <HtmlOutput html={section2} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerInfo;
